import * as d3 from 'd3';
import { addToStack, getPositionInScene } from "../Util";
import { createNewItem, select } from "../canvasSlice";
import store from "../store";

let clickHeld = false, moved = false, downX, downY;

export const mouseDown = (e, scene) => {
    clickHeld = true;
    const p = getPositionInScene(e.clientX, e.clientY);
    downX = p[0];
    downY = p[1];
}

export const mouseUp = (e, scene, datasets, renderer, undoStack) => {
    clickHeld = false;
    let c = d3.select("#lineToolUI");
    c.style("visibility", "hidden");
    if (moved) {
        addToStack(scene, datasets, undoStack);
        let r = scene.mark("line", {x1: parseInt(c.attr("x1")), y1: parseInt(c.attr("y1")), 
            x2: parseInt(c.attr("x2")), y2: parseInt(c.attr("y2"))});
        store.dispatch(createNewItem(r.id));
        store.dispatch(select([r.id]));
        renderer.render(scene);
    }
    moved = false;
}

export const mouseMove = (e, scene) => {
    if (!clickHeld) return;
    moved = true;
    let p = getPositionInScene(e.clientX, e.clientY), x2, y2;
    if (e.shiftKey) {
        let angle = Math.atan2(p[1] - downY, p[0] - downX) * 180 / Math.PI,
            angleR = Math.round(angle/45) * 45 * Math.PI/180, 
            dist = Math.sqrt(Math.pow(p[1] - downY, 2) + Math.pow(p[0] - downX, 2));
        x2 = downX + Math.cos(angleR) * dist;
        y2 = downY + Math.sin(angleR) * dist;
    } else {
        x2 = p[0];
        y2 = p[1];
    }
    d3.select("#lineToolUI").style("visibility", "visible").attr("x1", downX).attr("y1", downY)
            .attr("x2", x2).attr("y2", y2);
}